/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createPaginatedListOfConversionFactorSummaryFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, serializeCreateConversionFactorCommand, type CreateConversionFactorCommand, type PaginatedListOfConversionFactorSummary, type ProblemDetails } from '../models/index.js';
// @ts-ignore
import { ConversionfactorsItemRequestBuilderNavigationMetadata, ConversionfactorsItemRequestBuilderRequestsMetadata, type ConversionfactorsItemRequestBuilder } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Guid, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /conversionfactors
 */
export interface ConversionfactorsRequestBuilder extends BaseRequestBuilder<ConversionfactorsRequestBuilder> {
    /**
     * Gets an item from the ApiSdk.conversionfactors.item collection
     * @param id Unique identifier of the item
     * @returns {ConversionfactorsItemRequestBuilder}
     */
     byId(id: Guid) : ConversionfactorsItemRequestBuilder;
    /**
     * GetConversionFactors
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PaginatedListOfConversionFactorSummary>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<ConversionfactorsRequestBuilderGetQueryParameters> | undefined) : Promise<PaginatedListOfConversionFactorSummary | undefined>;
    /**
     * CreateConversionFactor
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Guid>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     post(body: CreateConversionFactorCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Guid | undefined>;
    /**
     * GetConversionFactors
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<ConversionfactorsRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
    /**
     * CreateConversionFactor
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: CreateConversionFactorCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * GetConversionFactors
 */
export interface ConversionfactorsRequestBuilderGetQueryParameters {
    criteria?: string;
    pageNumber?: number;
    pageSize?: number;
    sortExpression?: string;
}
/**
 * Uri template for the request builder.
 */
export const ConversionfactorsRequestBuilderUriTemplate = "{+baseurl}/conversionfactors{?Criteria*,PageNumber*,PageSize*,SortExpression*}";
/**
 * Mapper for query parameters from symbol name to serialization name represented as a constant.
 */
const ConversionfactorsRequestBuilderGetQueryParametersMapper: Record<string, string> = {
    "criteria": "Criteria",
    "pageNumber": "PageNumber",
    "pageSize": "PageSize",
    "sortExpression": "SortExpression",
};
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const ConversionfactorsRequestBuilderNavigationMetadata: Record<Exclude<keyof ConversionfactorsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byId: {
        requestsMetadata: ConversionfactorsItemRequestBuilderRequestsMetadata,
        navigationMetadata: ConversionfactorsItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["id"],
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const ConversionfactorsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: ConversionfactorsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPaginatedListOfConversionFactorSummaryFromDiscriminatorValue,
        queryParametersMapper: ConversionfactorsRequestBuilderGetQueryParametersMapper,
    },
    post: {
        uriTemplate: ConversionfactorsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendPrimitive",
        responseBodyFactory:  "string",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeCreateConversionFactorCommand,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
